import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	oneProviderIsConnected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twoProvidersAreConnected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	threeOrMoreProvidersAreConnected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	supportLinkText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	setUpDeploymentsDetailIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	setUpDeploymentsDetailIssueTerminologyRefreshM4Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	supportLinkTextIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	oneProviderIsConnected: {
		id: 'software-releases-launch-card.latest-deployment.providers-list-tooltip-content.one-provider-is-connected',
		defaultMessage: '{providerName} is installed',
		description: 'Tells the user that their deployments provider is connected to Jira.',
	},
	twoProvidersAreConnected: {
		id: 'software-releases-launch-card.latest-deployment.providers-list-tooltip-content.two-providers-are-connected',
		defaultMessage: '2 deployment tools installed',
		description: 'Tells the user that their deployments providers are connected to Jira.',
	},
	threeOrMoreProvidersAreConnected: {
		id: 'software-releases-launch-card.latest-deployment.providers-list-tooltip-content.three-or-more-providers-are-connected',
		defaultMessage: '3+ deployment tools installed',
		description: 'Tells the user that their deployments providers are connected to Jira.',
	},
	supportLinkText: {
		id: 'software-releases-launch-card.latest-deployment.providers-list-tooltip-content.support-link-text',
		defaultMessage: 'Learn how to link development work to issues',
		description:
			'Link text for the link that redirects users to support documentation on how to connect their development data with their Jira issues.',
	},
	setUpDeploymentsDetailIssueTerminologyRefreshM4: {
		id: 'software-releases-launch-card.latest-deployment.providers-list-tooltip-content.set-up-deployments-detail-issue-terminology-refresh-m4',
		defaultMessage:
			'To track deployments in Jira, start linking your work to work items in this project.',
		description: 'Explanation of why the user should set up their Jira + deployments integration.',
	},
	setUpDeploymentsDetailIssueTerminologyRefreshM4Galaxia: {
		id: 'software-releases-launch-card.latest-deployment.providers-list-tooltip-content.set-up-deployments-detail-issue-terminology-refresh-m4-galaxia',
		defaultMessage:
			'To track deployments in Jira, start linking your work to work items in this space.',
		description: 'Explanation of why the user should set up their Jira + deployments integration.',
	},
	supportLinkTextIssueTerminologyRefreshM4: {
		id: 'software-releases-launch-card.latest-deployment.providers-list-tooltip-content.support-link-text-issue-terminology-refresh-m4',
		defaultMessage: 'Learn how to link development work to work items',
		description:
			'Link text for the link that redirects users to support documentation on how to connect their development data with their Jira issues.',
	},
});
export default messages;
